// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__JPmqw","messageContainer":"style_messageContainer__3mvhJ"};